<div *ngIf="vm" class="center-align">
  <div class="top-panel">
    <mat-toolbar class="mat-toolbar generator-lists">
      <div *ngIf="vm.rowData.length !== 0" class="search-results-header text-wrap-long">
        <span aria-hidden="true" class="fa fa-book icon"></span>
        {{ vm.rowData.length === 1 ? 'Inventory Search Result' : 'Inventory Search Results' }}
        ({{ vm.rowData.length }} {{ vm.rowData.length === 1 ? 'Result' : 'Results' }})
      </div>
      <div *ngIf="vm.rowData.length === 0">
        <p>No Results Found</p>
      </div>
    </mat-toolbar>
  </div>
  <div class="asset-data">
    <mat-nav-list>
      <div *ngIf="vm.showLoading">
        <div class="lmask"></div>
      </div>

      <div *ngFor="let searchdata of vm.rowData; index as i; trackBy: trackByAssetId" class="asset-item">
        <p class="flex-container">
          <span class="flex-left">
            <span class="text-type-bold pr-2">{{ searchdata.assetType }} :</span>
            <a class="text-wrap-long" (click)="assetDetails(searchdata)">
              <span class="text-type-bold">
                {{ searchdata.qrCodeAssetId ?? '-' }} / 
                {{ searchdata.localId ?? '-' }} / 
                {{ searchdata.dbId ?? '-' }}
              </span>
            </a>
          </span>
          <button class="round-icon material-icons btn btn-white" title="Edit" (click)="assetEdit(searchdata)">edit</button>
        </p>
        <p *ngIf="searchdata.assetType === 'Generator'" 
           [ngClass]="{'text-type-bold text-type-warning-colour': searchdata.powerSupplyId !== undefined}" 
           mat-list-item>
          <span class="text-type-bold">Deployed: </span>{{ searchdata.powerSupplyId !== undefined ? 'Yes' : 'No' }}
        </p>
        <div *ngIf="searchdata.assetType === 'Generator'">
          <div *ngIf="searchdata.powerSupplyId !== undefined">
            <p mat-list-item><span class="text-type-bold">Power Supply: </span>
              <a class="text-wrap-long" (click)="powerSupplyDetails(searchdata.powerSupplyId)">
                <span class="text-type-bold">
                  {{ searchdata.powerSupplyName ?? 'N/A' }}
                </span>
              </a>
            </p>
            <p mat-list-item><span class="text-type-bold">Location: </span>
              {{ searchdata.location ?? 'N/A' }}
            </p>
            <p mat-list-item><span class="text-type-bold">Runtime (In Minutes): </span>
              {{ (searchdata.runtime === 0 || searchdata.runtime) ? searchdata.runtime : 'N/A' }}
            </p>
            <p mat-list-item><span class="text-type-bold">Refuel Due Time: </span>
              {{ parseRefuelDueDate(searchdata.refuelDueDate) | date: 'hh:mm a, MMM d, yyyy' || 'N/A' }}
            </p>
            <p class="mb-2" mat-list-item><span class="mb-1 text-type-bold">Comments: </span>{{ searchdata.comments ?? 'N/A' }}</p>
          </div>

          <p mat-list-item><span class="text-type-bold">Serial Number: </span>{{ searchdata.serialNumber ?? 'N/A' }}</p>
          <p mat-list-item><span class="text-type-bold">Manufacturer: </span>{{ searchdata.manufacture ?? '-' }}</p>
          <p mat-list-item><span class="text-type-bold">Model: </span>{{ searchdata.model ?? '-' }}</p>
          <p *ngIf="searchdata.powerSupplyId !== undefined" class="mb-2" mat-list-item>
            <span class="text-type-bold">Node: </span>{{ searchdata.node ?? '-' }}
          </p>
        </div>

        <div *ngIf="searchdata.assetType === 'Trailer'">
          <p mat-list-item><span class="text-type-bold">Trailer Name: </span>{{ searchdata.trailerName ?? 'N/A' }}</p>
          <p mat-list-item><span class="text-type-bold">License Plate: </span>{{ searchdata.licensePlate ?? 'N/A' }}</p>
          <p mat-list-item><span class="text-type-bold">Trailer Size: </span>{{ searchdata.trailerSize ?? 'N/A' }}</p>
          <p class="mb-2" mat-list-item>
            <span class="text-type-bold">Generator Capacity: </span>{{ searchdata.generatorCapacity ?? 'N/A' }}</p>
        </div>

        <!-- Common fields for all assets -->
        <p mat-list-item><span class="text-type-bold">Division: </span>{{ searchdata.division ?? '-' }}</p>
        <p mat-list-item><span class="text-type-bold">Region: </span>{{ searchdata.region ?? '-' }}</p>
        <p *ngIf="searchdata.assetType === 'Fuel Tank'" mat-list-item>
          <span class="text-type-bold">Capacity (Gallons): </span>{{ searchdata.capacityGallons ?? '-' }}
        </p>
        <p mat-list-item><span class="text-type-bold">Owner: </span>{{ searchdata.owner ?? '-' }}</p>
        <p mat-list-item>
          <span class="text-type-bold">Loaned Team: </span>{{ searchdata.loanedTeam ?? '-' }}
        </p>
        <p mat-list-item><span class="text-type-bold">Status: </span>{{ searchdata.status ?? '-' }}</p>

        <div *ngIf="searchdata.assetType === 'Generator'" class="button-container">
          <button
            *ngIf="searchdata.powerSupplyId === undefined"
            class="custom-width-deploy-btn deploy-generator-bg-color power-source-label"
            mat-raised-button
            (click)="openDeployGeneratorDialog(searchdata)">
            Deploy Generator
          </button>
          <div *ngIf="searchdata.powerSupplyId !== undefined" class="recover-refuel-container">
            <button
              class="power-source-label recover-generator-bg-color"
              mat-raised-button
              (click)="openRefuelRecoverDialog(searchdata, 'Recover')">
              Recover Generator
            </button>
            <button
              class="power-source-label refuel-generator-bg-color"
              mat-raised-button
              (click)="openRefuelRecoverDialog(searchdata, 'Refuel')">
              Refuel Generator
            </button>
          </div>
        </div>
        <hr class="horizontal-line">
      </div>
    </mat-nav-list>
</div>
